module.exports = __webpack_public_path__ + "media/images/admin/icons/alert-circle-9f6ed1b94fd732b3c7a3fd611960b1f5.svg";